export class MinMaxModel {
  constructor(public target = '', public operation: 'GREATEST' | 'LEAST' = 'GREATEST', public columns: string[] = []) {}
}
